// // import React, { useState } from "react";
// // import { DialogBox } from "../../../../../components/Elements/DialogBox";
// // import { Input, Checkbox, Button, Select } from "antd";
// // import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";

// // const { Option } = Select;

// // const userList = ["Mukesh", "Praveen", "John", "Amit"];

// // const frequencyOptions = ["Yearly", "Half Yearly", "Quarterly", "Monthly"];
// // const yearOptions = ["financial year", "Calendar year"];

// // const para = [
// //   "(If the admin has chosen yearly, the system will assign one form or section to each user with a label.)",
// //   "(If the admin has chosen half-yearly, the system will assign two forms or sections to each user with a label.)",
// //   "If the admin has chosen quarterly, the system will assign four forms or sections to each user with a label.",
// //   "If the admin has chosen monthly, the system will assign 12 forms or sections to each user with a label.",
// // ];

// // const ProjectSetup = ({ onOpen, onClose }) => {
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [selectedUsers, setSelectedUsers] = useState([]);
// //   const [savedUsers, setSavedUsers] = useState([]);
// //   const [selectedYear, setSelectedYear] = useState(null);
// //   const [selectedFrequency, setSelectedFrequency] = useState(null);
// //   const [yearType, setYearType] = useState(null);

// //   const financialYears = ["2021-2022", "2022-2023", "2023-2024"];
// //   const calendarYears = ["2021", "2022", "2023", "2024"];

// //   const handleYearTypeChange = (value) => {
// //     setYearType(value);
// //     setSelectedYear(null); // reset year on type change
// //   };
// //   const handleUserCheck = (name) => {
// //     setSelectedUsers((prev) =>
// //       prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
// //     );
// //   };

// //   const handleSave = () => {
// //     setSavedUsers(selectedUsers);
// //   };

// //   const handleDelete = (name) => {
// //     setSavedUsers((prev) => prev.filter((n) => n !== name));
// //     setSelectedUsers((prev) => prev.filter((n) => n !== name));
// //   };

// //   const filteredUsers = userList.filter((name) =>
// //     name.toLowerCase().includes(searchTerm.toLowerCase()),
// //   );

// //   return (
// //     <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
// //       <div className="space-y-4 px-4 py-2">
// //         <h3 className="text-lg text-[#000000] ">Project Set-up</h3>
// //         <hr></hr>
// //         {/* Select Project Admin */}
// //         <div className="space-y-2">
// //           <h4 className="text-base font-semibold">Select Project Admin</h4>
// //           <Input
// //             placeholder="Search user"
// //             prefix={<SearchOutlined />}
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //           />
// //           <div className="space-y-2 pt-2">
// //             {filteredUsers.map((name) => (
// //               <div
// //                 key={name}
// //                 className="flex justify-between items-center px-2 py-1 border rounded-md"
// //               >
// //                 <span>{name}</span>
// //                 {savedUsers.includes(name) ? (
// //                   <DeleteOutlined
// //                     className="text-red-500 cursor-pointer"
// //                     onClick={() => handleDelete(name)}
// //                   />
// //                 ) : (
// //                   <Checkbox
// //                     checked={selectedUsers.includes(name)}
// //                     onChange={() => handleUserCheck(name)}
// //                   />
// //                 )}
// //               </div>
// //             ))}
// //           </div>

// //           {/* Save Button */}
// //           <div className="pt-2 px-4 flex justify-center">
// //             <Button
// //               onClick={handleSave}
// //               style={{
// //                 background: "#06513D",
// //                 color: "white",
// //                 borderRadius: "8px",
// //               }}
// //             >
// //               Save
// //             </Button>
// //           </div>
// //         </div>

// //         {/* Select Year and Frequency */}
// //         <div className="pt-6 space-y-4">
// //           <h4 className="text-base font-semibold">
// //             Select Year for which data has to be Filled
// //           </h4>
// //           <div className="space-y-3">
// //             <Select
// //               placeholder="Select Year Type"
// //               value={yearType}
// //               onChange={handleYearTypeChange}
// //               style={{ width: "100%" }}
// //             >
// //               <Option value="financial">Financial Year</Option>
// //               <Option value="calendar">Calendar Year</Option>
// //             </Select>

// //             {yearType && (
// //               <Select
// //                 placeholder={`Select ${yearType === "financial" ? "Financial" : "Calendar"} Year`}
// //                 value={selectedYear}
// //                 onChange={setSelectedYear}
// //                 style={{ width: "100%" }}
// //               >
// //                 {(yearType === "financial"
// //                   ? financialYears
// //                   : calendarYears
// //                 ).map((year) => (
// //                   <Option key={year} value={year}>
// //                     {year}
// //                   </Option>
// //                 ))}
// //               </Select>
// //             )}
// //           </div>

// //           <h4 className="text-base font-semibold">
// //             Select Frequency of form to be Filled
// //           </h4>

// //           <div className="space-y-2">
// //             {frequencyOptions.map((freq, index) => (
// //               <div
// //                 key={freq}
// //                 className="flex items-start justify-between px-2 py-2 border rounded-md"
// //               >
// //                 <div className="flex items-center gap-2">
// //                   <Checkbox
// //                     checked={selectedFrequency === freq}
// //                     onChange={() =>
// //                       setSelectedFrequency(
// //                         selectedFrequency === freq ? null : freq,
// //                       )
// //                     }
// //                   />
// //                   <div>
// //                     <span className="font-medium">{freq}</span>
// //                     <p className="text-xs text-gray-500">{para[index]}</p>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>

// //           {selectedFrequency && (
// //             <div className="pt-4 space-y-2 border p-4 rounded-md border-[#d9d9d9]">
// //               <p className="font-semibold text-sm">{selectedFrequency}</p>
// //               <div className="space-y-1">
// //                 {yearOptions.map((year) => (
// //                   <div
// //                     key={year}
// //                     className="flex justify-between px-3 py-2 bg-gray-100 rounded-md"
// //                   >
// //                     <span className="font-medium">{year}</span>
// //                     <span className="text-sm text-gray-600 italic">
// //                       Lorem ipsum description for{" "}
// //                       {selectedFrequency.toLowerCase()}
// //                     </span>
// //                   </div>
// //                 ))}
// //               </div>
// //               <p className="text-xs italic text-gray-500 pt-2">
// //                 (If the admin has chosen {selectedFrequency.toLowerCase()}, the
// //                 system will assign one form or section to each user with a
// //                 label.)
// //               </p>
// //             </div>
// //           )}
// //         </div>

// //         <div className="space-y-6">
// //           <div className="border rounded-md p-3">
// //             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
// //               Standard Form
// //             </h5>
// //             <div className="space-y-3">
// //               {["Basic Details Form", "BRSR"].map((label) => (
// //                 <div
// //                   key={label}
// //                   className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
// //                 >
// //                   <div className="flex items-center gap-2 w-full sm:w-auto">
// //                     <Checkbox
// //                       className="custom-green-checkbox"
// //                       style={{
// //                         borderColor: "#06513D",
// //                       }}
// //                     />
// //                     <span className="text-sm">{label}</span>
// //                   </div>
// //                   <Select
// //                     placeholder="Frequency"
// //                     style={{
// //                       width: 150,
// //                       borderColor: "#06513D",
// //                     }}
// //                     size="small"
// //                     className="custom-green-select"
// //                     dropdownStyle={{ borderColor: "#06513D" }}
// //                   >
// //                     {frequencyOptions.map((freq) => (
// //                       <Option key={freq} value={freq}>
// //                         {freq}
// //                       </Option>
// //                     ))}
// //                   </Select>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           <div className="border rounded-md p-3">
// //             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
// //               Dynamics Form
// //             </h5>
// //             <div className="space-y-3">
// //               {["Basic Details Form", "BRSR"].map((label) => (
// //                 <div
// //                   key={label}
// //                   className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
// //                 >
// //                   <div className="flex items-center gap-2 w-full sm:w-auto">
// //                     <Checkbox
// //                       className="custom-green-checkbox"
// //                       style={{
// //                         borderColor: "#06513D",
// //                       }}
// //                     />
// //                     <span className="text-sm">{label}</span>
// //                   </div>
// //                   <Select
// //                     placeholder="Frequency"
// //                     style={{
// //                       width: 150,
// //                       borderColor: "#06513D",
// //                     }}
// //                     size="small"
// //                     className="custom-green-select"
// //                     dropdownStyle={{ borderColor: "#06513D" }}
// //                   >
// //                     {frequencyOptions.map((freq) => (
// //                       <Option key={freq} value={freq}>
// //                         {freq}
// //                       </Option>
// //                     ))}
// //                   </Select>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>

// //         <div className="pt-2 px-4 flex justify-center">
// //           <Button
// //             onClick={handleSave}
// //             style={{
// //               background: "#06513D",
// //               color: "white",
// //               borderRadius: "8px",
// //             }}
// //           >
// //             Save
// //           </Button>
// //         </div>
// //       </div>
// //     </DialogBox>
// //   );
// // };

// // export default ProjectSetup;

// import React, { useState, useCallback, useEffect, useMemo } from "react";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { Input, Checkbox, Button, Select, Modal } from "antd";
// import {
//   SearchOutlined,
//   DeleteOutlined,
//   ExclamationCircleOutlined,
// } from "@ant-design/icons";
// import { useSelector } from "react-redux";
// const { Option } = Select;
// const { confirm } = Modal;

// const userList = [
//   "Mukesh",
//   "Praveen",
//   "John",
//   "Amit",
//   "Suresh",
//   "Priya",
//   "Ravi",
// ];

// const frequencyOptions = ["Yearly", "Half Yearly", "Quarterly", "Monthly"];
// const yearOptions = ["financial year", "Calendar year"];

// const para = [
//   "(If the admin has chosen yearly, the system will assign one form or section to each user with a label.)",
//   "(If the admin has chosen half-yearly, the system will assign two forms or sections to each user with a label.)",
//   "If the admin has chosen quarterly, the system will assign four forms or sections to each user with a label.",
//   "If the admin has chosen monthly, the system will assign 12 forms or sections to each user with a label.",
// ];

// const ProjectSetup = ({ onOpen, onClose, projectId }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [savedUsers, setSavedUsers] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(null);
//   const [selectedFrequency, setSelectedFrequency] = useState(null);
//   const [yearType, setYearType] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const financialYears = ["2021-2022", "2022-2023", "2023-2024", "2024-2025"];
//   const calendarYears = ["2021", "2022", "2023", "2024"];
//   const [dynamicTableData, setDynamicTableData] = useState([]);
//   const [rawUsers, setRawUsers] = useState([]);

//   const user_data = useSelector((state) => state.auth.user);

//   const [users, setUsers] = useState([]); // Full user data with name/email

//   const pageSize = 10; // or your preferred default

//   const handleYearTypeChange = (value) => {
//     setYearType(value);
//     setSelectedYear(null); // reset year on type change
//   };

//   const filteredUsers = useMemo(() => {
//     return rawUsers.filter((user) =>
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()),
//     );
//   }, [searchTerm, rawUsers]);

//   const handleUserCheck = (name) => {
//     setSelectedUsers((prev) =>
//       prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
//     );
//   };

//   const handleSave = () => {
//     setSavedUsers([...savedUsers, ...selectedUsers]);
//     setSelectedUsers([]);
//   };

//   const showDeleteConfirm = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   const handleDelete = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//     setSelectedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   // Delete confirmation popup

//   // Filter users based on search term and exclude already saved users

//   // Get placeholder text for year selection
//   const getYearPlaceholder = () => {
//     if (!yearType) return "Select Year";
//     return yearType === "financial"
//       ? "Select Financial Year"
//       : "Select Calendar Year";
//   };

//   const fetchTableData = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_STANDARDFORM(projectId),
//       });

//       if (response?.success) {
//         setTableData(response.data); // store full raw data
//       }
//     } catch (error) {
//       console.error("Error fetching standard survey forms:", error);
//     }
//   }, [projectId]);

//   const fetchTableDataDynamic = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
//       });
//       if (response?.success) {
//         setDynamicTableData(response.data); // store raw API data
//       }
//     } catch (error) {
//       console.error("Error fetching dynamic forms:", error);
//     }
//   }, [projectId]);

//   const fetchUsers = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(user_data._id),
//       });

//       if (response.data) {
//         setRawUsers(response.data); // save raw data
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   useEffect(() => {
//     fetchTableData();
//     fetchTableDataDynamic();
//     fetchUsers(); // ✅ add this call
//   }, [fetchTableData, fetchTableDataDynamic]);

//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
//       <div className="space-y-4 px-4 py-2">
//         <h3 className="text-lg text-[#000000]">Project Set-up</h3>
//         <hr />

//         {/* Select Project Admin */}

//         <div className="space-y-2">
//           <h4 className="text-base font-semibold">Select Project Admin</h4>

//           {/* Search Bar */}
//           <Input
//             placeholder="Search user"
//             prefix={<SearchOutlined />}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />

//           {/* Show filtered users only when searching */}
//           {searchTerm && (
//             <div className="space-y-2 pt-2 max-h-40 overflow-y-auto">
//               {filteredUsers.map((user) => (
//                 <div
//                   key={user._id}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md hover:bg-gray-50"
//                 >
//                   <span>{user.name}</span>
//                   <Checkbox
//                     checked={selectedUsers.includes(user.name)}
//                     onChange={() => handleUserCheck(user.name)}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Selected Users */}
//           {selectedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-gray-600">
//                 Selected Users:
//               </h5>
//               {selectedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-blue-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <Button
//                     size="small"
//                     type="text"
//                     onClick={() => handleUserCheck(name)}
//                     className="text-red-500"
//                   >
//                     Remove
//                   </Button>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Saved Users */}
//           {savedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-[#06513D]">
//                 Saved Project Admins:
//               </h5>
//               {savedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-green-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <DeleteOutlined
//                     className="text-red-500 cursor-pointer hover:text-red-700 hover:scale-110 transition-all duration-200"
//                     onClick={() => showDeleteConfirm(name)}
//                     title={`Delete ${name}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Save Button */}
//           {selectedUsers.length > 0 && (
//             <div className="pt-2 px-4 flex justify-center">
//               <Button
//                 onClick={handleSave}
//                 style={{
//                   background: "#06513D",
//                   color: "white",
//                   borderRadius: "8px",
//                 }}
//               >
//                 Save Selected Users
//               </Button>
//             </div>
//           )}
//         </div>

//         {/* Select Year and Frequency */}
//         <div className="pt-6 space-y-4">
//           {/* Year Selection in Single Row */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year Type
//               </label>
//               <Select
//                 placeholder="Select Year Type"
//                 value={yearType}
//                 onChange={handleYearTypeChange}
//                 style={{ width: "100%" }}
//               >
//                 <Option value="financial">Financial Year</Option>
//                 <Option value="calendar">Calendar Year</Option>
//               </Select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year
//               </label>
//               <Select
//                 placeholder={getYearPlaceholder()}
//                 value={selectedYear}
//                 onChange={setSelectedYear}
//                 style={{ width: "100%" }}
//                 disabled={!yearType}
//               >
//                 {(yearType === "financial"
//                   ? financialYears
//                   : calendarYears
//                 ).map((year) => (
//                   <Option key={year} value={year}>
//                     {year}
//                   </Option>
//                 ))}
//               </Select>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-2">
//             {/* Column 1 */}
//             <div className="space-y-2">
//               {[frequencyOptions[0], frequencyOptions[1]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${
//                     selectedFrequency === freq
//                       ? "border-[#06513D] bg-green-50"
//                       : "border-gray-300"
//                   }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index]}</p>
//                 </div>
//               ))}
//             </div>

//             {/* Column 2 */}
//             <div className="space-y-2">
//               {[frequencyOptions[2], frequencyOptions[3]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${
//                     selectedFrequency === freq
//                       ? "border-[#06513D] bg-green-50"
//                       : "border-gray-300"
//                   }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index + 2]}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="space-y-6">

//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Standard Form
//             </h5>
//             <div className="space-y-3">
//               {tableData.map((item) => (
//                 <div
//                   key={item._id}
//                   className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                 >
//                   <div className="flex items-center gap-2 w-full sm:w-auto">
//                     {/* <Checkbox className="custom-green-checkbox" /> */}
//                     <span className="text-sm">{item.title}</span>
//                   </div>
//                   <Select
//                     placeholder="Frequency"
//                     style={{ width: 150 }}
//                     size="small"
//                   >
//                     {frequencyOptions.map((freq) => (
//                       <Option key={freq} value={freq}>
//                         {freq}
//                       </Option>
//                     ))}
//                   </Select>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Dynamic Form
//             </h5>
//             <div className="space-y-3">
//               {dynamicTableData.map((item) => (
//                 <div
//                   key={item._id}
//                   className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                 >
//                   <div className="flex items-center gap-2 w-full sm:w-auto">
//                     {/* <Checkbox className="custom-green-checkbox" /> */}
//                     <span className="text-sm">{item.title}</span>
//                   </div>
//                   <Select
//                     placeholder="Frequency"
//                     style={{ width: 150 }}
//                     size="small"
//                   >
//                     {frequencyOptions.map((freq) => (
//                       <Option key={freq} value={freq}>
//                         {freq}
//                       </Option>
//                     ))}
//                   </Select>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="pt-2 px-4 flex justify-center">
//           <Button
//             onClick={onClose}
//             style={{
//               background: "#06513D",
//               color: "white",
//               borderRadius: "8px",
//             }}
//           >
//             Complete Setup
//           </Button>
//         </div>
//       </div>
//     </DialogBox>
//   );
// };

// export default ProjectSetup;

// const ProjectSetup = ({ onOpen, onClose, projectId, statusFrequency }) => {
//   console.log("Status Frequency in ProjectSetup:", statusFrequency);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [savedUsers, setSavedUsers] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(null);
//   const [selectedFrequency, setSelectedFrequency] = useState(null);
//   const [yearType, setYearType] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const financialYears = ["2021-2022", "2022-2023", "2023-2024", "2024-2025"];
//   const calendarYears = ["2021", "2022", "2023", "2024"];
//   const [dynamicTableData, setDynamicTableData] = useState([]);
//   const [rawUsers, setRawUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });

//   // State to track individual form frequencies
//   const [standardFormFrequencies, setStandardFormFrequencies] = useState({});
//   const [dynamicFormFrequencies, setDynamicFormFrequencies] = useState({});

//   const user_data = useSelector((state) => state.auth.user);

//   const [users, setUsers] = useState([]); // Full user data with name/email

//   const pageSize = 10; // or your preferred default

//   const handleYearTypeChange = (value) => {
//     setYearType(value);
//     setSelectedYear(null); // reset year on type change
//   };

//   const filteredUsers = useMemo(() => {
//     return rawUsers.filter((user) =>
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()),
//     );
//   }, [searchTerm, rawUsers]);

//   const handleUserCheck = (name) => {
//     setSelectedUsers((prev) =>
//       prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
//     );
//   };

//   const handleSave = () => {
//     setSavedUsers([...savedUsers, ...selectedUsers]);
//     setSelectedUsers([]);
//   };

//   const showDeleteConfirm = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   const handleDelete = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//     setSelectedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   // Handle frequency change for standard forms
//   const handleStandardFormFrequencyChange = (formId, frequency) => {
//     setStandardFormFrequencies((prev) => ({
//       ...prev,
//       [formId]: frequency,
//     }));
//   };

//   // Handle frequency change for dynamic forms
//   const handleDynamicFormFrequencyChange = (formId, frequency) => {
//     setDynamicFormFrequencies((prev) => ({
//       ...prev,
//       [formId]: frequency,
//     }));
//   };

//   const triggerPopup = (type, title, message, duration = 3000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(() => setShowPopup(false), duration);
//   };

//   // Convert backend frequency to frontend format
//   const convertFrequencyToFrontend = (frequency) => {
//     const frequencyMap = {
//       year: "Yearly",
//       half_year: "Half Yearly",
//       quarter: "Quarterly",
//       month: "Monthly",
//     };
//     return frequencyMap[frequency] || frequency;
//   };

//   // Convert frontend frequency to backend format
//   const convertFrequencyToBackend = (frequency) => {
//     const frequencyMap = {
//       Yearly: "year",
//       "Half Yearly": "half_year",
//       Quarterly: "quarter",
//       Monthly: "month",
//     };
//     return frequencyMap[frequency] || frequency.toLowerCase();
//   };

//   // Fetch project details to pre-fill existing data
//   const fetchProjectDetails = async () => {
//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
//       });

//       if (response?.success) {
//         const projectData = response.data;

//         // Set year type and year value
//         if (projectData.year) {
//           setYearType(projectData.year); // "calendar" or "financial"
//         }
//         if (projectData.year_value) {
//           setSelectedYear(projectData.year_value); // "2023", "2021-2022", etc.
//         }

//         // Set standard form frequencies
//         if (projectData.standard_form && Array.isArray(projectData.standard_form)) {
//           const standardFreqs = {};
//           projectData.standard_form.forEach(form => {
//             if (form.id && form.frequency) {
//               standardFreqs[form.id] = convertFrequencyToFrontend(form.frequency);
//             }
//           });
//           setStandardFormFrequencies(standardFreqs);
//         }

//         // Set dynamic form frequencies
//         if (projectData.dynamic_form && Array.isArray(projectData.dynamic_form)) {
//           const dynamicFreqs = {};
//           projectData.dynamic_form.forEach(form => {
//             if (form.id && form.frequency) {
//               dynamicFreqs[form.id] = convertFrequencyToFrontend(form.frequency);
//             }
//           });
//           setDynamicFormFrequencies(dynamicFreqs);
//         }

//         console.log("Project details loaded:", {
//           yearType: projectData.year,
//           yearValue: projectData.year_value,
//           standardForms: projectData.standard_form,
//           dynamicForms: projectData.dynamic_form
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching project details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const saveFrequencySettings = async () => {
//     try {
//       setLoading(true);

//       // Validate required fields
//       if (!yearType || !selectedYear) {
//         message.error("Please select year type and year");
//         return;
//       }

//       // Prepare standard forms payload
//       const standardForms = tableData
//         .filter((item) => standardFormFrequencies[item._id])
//         .map((item) => ({
//           id: item._id,
//           frequency: convertFrequencyToBackend(
//             standardFormFrequencies[item._id],
//           ),
//         }));

//       // Prepare dynamic forms payload
//       const dynamicForms = dynamicTableData
//         .filter((item) => dynamicFormFrequencies[item._id])
//         .map((item) => ({
//           id: item._id,
//           frequency: convertFrequencyToBackend(
//             dynamicFormFrequencies[item._id],
//           ),
//         }));

//       const payload = {
//         year: yearType, // "calendar" or "financial"
//         year_value: selectedYear,
//         standard_form: standardForms,
//         dynamic_form: dynamicForms,
//       };

//       console.log("Sending payload:", payload);

//       const response = await postApi({
//         apiUrl: `/api/client/project/set-up/frequency/${projectId}`,
//         data: payload,
//       });

//       if (response?.success) {
//         // Show success popup
//         triggerPopup(
//           "success",
//           "Success",
//           "Frequency settings saved successfully!",
//         );

//         // Close the dialog after popup duration (3 seconds)
//         setTimeout(() => {
//           onClose();
//         }, 3000);
//       } else {
//         message.error(response?.message || "Failed to save frequency settings");
//       }
//     } catch (error) {
//       console.error("Error saving frequency settings:", error);
//       message.error("An error occurred while saving frequency settings");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get placeholder text for year selection
//   const getYearPlaceholder = () => {
//     if (!yearType) return "Select Year";
//     return yearType === "financial"
//       ? "Select Financial Year"
//       : "Select Calendar Year";
//   };

//   const fetchTableData = useCallback(
//     async (searchValue = "") => {
//       try {
//         const response = await getApi({
//           apiUrl: API_URLS.GET_STANDARDFORM(projectId, searchValue),
//         });

//         if (response?.success) {
//           setTableData(response.data); // store full raw data
//         }
//       } catch (error) {
//         console.error("Error fetching standard survey forms:", error);
//       }
//     },
//     [projectId],
//   );

//   const fetchTableDataDynamic = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
//       });
//       if (response?.success) {
//         setDynamicTableData(response.data); // store raw API data
//       }
//     } catch (error) {
//       console.error("Error fetching dynamic forms:", error);
//     }
//   }, [projectId]);

//   const fetchUsers = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(user_data._id),
//       });

//       if (response.data) {
//         setRawUsers(response.data); // save raw data
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   useEffect(() => {
//     // Fetch project details first to pre-fill data
//     fetchProjectDetails();

//     // Then fetch other data
//     fetchTableData();
//     fetchTableDataDynamic();
//     fetchUsers();
//   }, [fetchTableData, fetchTableDataDynamic]);

//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
//       <div className="space-y-4 px-4 py-2">
//         <h3 className="text-lg text-[#000000]">Project Set-up</h3>
//         <hr />

//         {/* Select Project Admin */}
//         <div className="space-y-2">
//           <h4 className="text-base font-semibold">Select Project Admin</h4>

//           {/* Search Bar */}
//           <Input
//             placeholder="Search user"
//             prefix={<SearchOutlined />}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />

//           {/* Show filtered users only when searching */}
//           {searchTerm && (
//             <div className="space-y-2 pt-2 max-h-40 overflow-y-auto">
//               {filteredUsers.map((user) => (
//                 <div
//                   key={user._id}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md hover:bg-gray-50"
//                 >
//                   <span>{user.name}</span>
//                   <Checkbox
//                     checked={selectedUsers.includes(user.name)}
//                     onChange={() => handleUserCheck(user.name)}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Selected Users */}
//           {selectedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-gray-600">
//                 Selected Users:
//               </h5>
//               {selectedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-blue-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <Button
//                     size="small"
//                     type="text"
//                     onClick={() => handleUserCheck(name)}
//                     className="text-red-500"
//                   >
//                     Remove
//                   </Button>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Saved Users */}
//           {savedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-[#06513D]">
//                 Saved Project Admins:
//               </h5>
//               {savedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-green-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <DeleteOutlined
//                     className="text-red-500 cursor-pointer hover:text-red-700 hover:scale-110 transition-all duration-200"
//                     onClick={() => showDeleteConfirm(name)}
//                     title={`Delete ${name}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Save Button */}
//           {selectedUsers.length > 0 && (
//             <div className="pt-2 px-4 flex justify-center">
//               <Button
//                 onClick={handleSave}
//                 style={{
//                   background: "#06513D",
//                   color: "white",
//                   borderRadius: "8px",
//                 }}
//               >
//                 Save Selected Users
//               </Button>
//             </div>
//           )}
//         </div>

//         {/* Select Year and Frequency */}
//         <div className="pt-6 space-y-4">
//           {/* Year Selection in Single Row */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year Type
//               </label>
//               <Select
//                 placeholder="Select Year Type"
//                 value={yearType}
//                 onChange={handleYearTypeChange}
//                 style={{ width: "100%" }}
//               >
//                 <Option value="financial">Financial Year</Option>
//                 <Option value="calendar">Calendar Year</Option>
//               </Select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year
//               </label>
//               <Select
//                 placeholder={getYearPlaceholder()}
//                 value={selectedYear}
//                 onChange={setSelectedYear}
//                 style={{ width: "100%" }}
//                 disabled={!yearType}
//               >
//                 {(yearType === "financial"
//                   ? financialYears
//                   : calendarYears
//                 ).map((year) => (
//                   <Option key={year} value={year}>
//                     {year}
//                   </Option>
//                 ))}
//               </Select>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-2">
//             {/* Column 1 */}
//             <div className="space-y-2">
//               {[frequencyOptions[0], frequencyOptions[1]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${
//                     selectedFrequency === freq
//                       ? "border-[#06513D] bg-green-50"
//                       : "border-gray-300"
//                   }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index]}</p>
//                 </div>
//               ))}
//             </div>

//             {/* Column 2 */}
//             <div className="space-y-2">
//               {[frequencyOptions[2], frequencyOptions[3]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${
//                     selectedFrequency === freq
//                       ? "border-[#06513D] bg-green-50"
//                       : "border-gray-300"
//                   }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index + 2]}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="space-y-6">
//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Standard Form
//             </h5>
//             <div className="space-y-3">
//               {tableData.length > 0 ? (
//                 tableData.map((item) => (
//                   <div
//                     key={item._id}
//                     className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                   >
//                     <div className="flex items-center gap-2 w-full sm:w-auto">
//                       <span className="text-sm">{item.title}</span>
//                     </div>
//                     <Select
//                       placeholder="Frequency"
//                       style={{ width: 150 }}
//                       size="small"
//                       value={standardFormFrequencies[item._id]}
//                       onChange={(value) =>
//                         handleStandardFormFrequencyChange(item._id, value)
//                       }
//                     >
//                       {frequencyOptions.map((freq) => (
//                         <Option key={freq} value={freq}>
//                           {freq}
//                         </Option>
//                       ))}
//                     </Select>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center py-0 text-gray-500">
//                   <p className="text-sm">No data available</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Dynamic Form
//             </h5>
//             <div className="space-y-3">
//               {dynamicTableData.length > 0 ? (
//                 dynamicTableData.map((item) => (
//                   <div
//                     key={item._id}
//                     className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                   >
//                     <div className="flex items-center gap-2 w-full sm:w-auto">
//                       <span className="text-sm">{item.title}</span>
//                     </div>
//                     <Select
//                       placeholder="Frequency"
//                       style={{ width: 150 }}
//                       size="small"
//                       value={dynamicFormFrequencies[item._id]}
//                       onChange={(value) =>
//                         handleDynamicFormFrequencyChange(item._id, value)
//                       }
//                     >
//                       {frequencyOptions.map((freq) => (
//                         <Option key={freq} value={freq}>
//                           {freq}
//                         </Option>
//                       ))}
//                     </Select>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center py-0 text-gray-500">
//                   <p className="text-sm">No data available</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="pt-2 px-4 flex justify-center">
//           <Button
//             onClick={saveFrequencySettings}
//             loading={loading}
//             style={{
//               background: "#06513D",
//               color: "white",
//               borderRadius: "8px",
//             }}
//             // disabled={statusFrequency === "unlock"}
//           >
//             Complete Setup
//           </Button>
//         </div>
//       </div>
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//           <PopupCard
//             type={popupData.type}
//             title={popupData.title}
//             message={popupData.message}
//           />
//         </div>
//       )}
//     </DialogBox>
//   );
// };

// export default ProjectSetup;

// import React, { useState, useCallback, useEffect, useMemo } from "react";
// import { getApi, postApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { Input, Checkbox, Button, Select, Modal, message } from "antd";
// import {
//   SearchOutlined,
//   DeleteOutlined,
//   ExclamationCircleOutlined,
// } from "@ant-design/icons";
// import { useSelector } from "react-redux";
// import PopupCard from "../../../../Auth/PopupCard";
// const { Option } = Select;
// const { confirm } = Modal;

// const userList = [
//   "Mukesh",
//   "Praveen",
//   "John",
//   "Amit",
//   "Suresh",
//   "Priya",
//   "Ravi",
// ];

// const frequencyOptions = ["Yearly", "Half Yearly", "Quarterly", "Monthly"];
// const yearOptions = ["financial year", "Calendar year"];

// const para = [
//   "(If the admin has chosen yearly, the system will assign one form or section to each user with a label.)",
//   "(If the admin has chosen half-yearly, the system will assign two forms or sections to each user with a label.)",
//   "If the admin has chosen quarterly, the system will assign four forms or sections to each user with a label.",
//   "If the admin has chosen monthly, the system will assign 12 forms or sections to each user with a label.",
// ];

// const ProjectSetup = ({ onOpen, onClose, projectId, statusFrequency }) => {
//   console.log("Status Frequency in ProjectSetup:", statusFrequency);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [savedUsers, setSavedUsers] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(null);
//   const [selectedFrequency, setSelectedFrequency] = useState(null);
//   const [yearType, setYearType] = useState(null);
//   const [tableData, setTableData] = useState([]);
//   const financialYears = ["2021-2022", "2022-2023", "2023-2024", "2024-2025"];
//   const calendarYears = ["2021", "2022", "2023", "2024"];
//   const [dynamicTableData, setDynamicTableData] = useState([]);
//   const [rawUsers, setRawUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });

//   // State to track individual form frequencies
//   const [standardFormFrequencies, setStandardFormFrequencies] = useState({});
//   const [dynamicFormFrequencies, setDynamicFormFrequencies] = useState({});

//   const user_data = useSelector((state) => state.auth.user);

//   const [users, setUsers] = useState([]); // Full user data with name/email

//   const pageSize = 10; // or your preferred default

//   const handleYearTypeChange = (value) => {
//     setYearType(value);
//     setSelectedYear(null); // reset year on type change
//   };

//   const filteredUsers = useMemo(() => {
//     return rawUsers.filter((user) =>
//       user.name.toLowerCase().includes(searchTerm.toLowerCase()),
//     );
//   }, [searchTerm, rawUsers]);

//   const handleUserCheck = (name) => {
//     setSelectedUsers((prev) =>
//       prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
//     );
//   };

//   const handleSave = () => {
//     setSavedUsers([...savedUsers, ...selectedUsers]);
//     setSelectedUsers([]);
//   };

//   const showDeleteConfirm = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   const handleDelete = (name) => {
//     setSavedUsers((prev) => prev.filter((n) => n !== name));
//     setSelectedUsers((prev) => prev.filter((n) => n !== name));
//   };

//   // Handle frequency change for standard forms
//   const handleStandardFormFrequencyChange = (formId, frequency) => {
//     setStandardFormFrequencies((prev) => ({
//       ...prev,
//       [formId]: frequency,
//     }));
//   };

//   // Handle frequency change for dynamic forms
//   const handleDynamicFormFrequencyChange = (formId, frequency) => {
//     setDynamicFormFrequencies((prev) => ({
//       ...prev,
//       [formId]: frequency,
//     }));
//   };

//   const triggerPopup = (type, title, message, duration = 10000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(() => setShowPopup(false), duration);
//   };

//   // Convert backend frequency to frontend format
//   const convertFrequencyToFrontend = (frequency) => {
//     const frequencyMap = {
//       year: "Yearly",
//       half_year: "Half Yearly",
//       quarter: "Quarterly",
//       month: "Monthly",
//     };
//     return frequencyMap[frequency] || frequency;
//   };

//   // Convert frontend frequency to backend format
//   const convertFrequencyToBackend = (frequency) => {
//     const frequencyMap = {
//       Yearly: "year",
//       "Half Yearly": "half_year",
//       Quarterly: "quarter",
//       Monthly: "month",
//     };
//     return frequencyMap[frequency] || frequency.toLowerCase();
//   };

//   // Enhanced validation function with specific messages
//   const validateFormFrequencies = () => {
//     const standardFormCount = Object.keys(standardFormFrequencies).filter(
//       (key) => standardFormFrequencies[key],
//     ).length;

//     const dynamicFormCount = Object.keys(dynamicFormFrequencies).filter(
//       (key) => dynamicFormFrequencies[key],
//     ).length;

//     const totalFormsWithFrequency = standardFormCount + dynamicFormCount;

//     if (totalFormsWithFrequency === 0) {
//       return {
//         isValid: false,
//         message:
//           "Please set the frequency for each form before completing the project setup. Frequency ensures how often the data will be collected and reported.",
//       };
//     }

//     return { isValid: true };
//   };

//   // Comprehensive validation function for Complete Setup button
//   const validateProjectSetup = () => {
//     const hasYearSelection = yearType && selectedYear;
//     const formValidation = validateFormFrequencies();

//     // Case 3: Both missing
//     if (!hasYearSelection && !formValidation.isValid) {
//       return {
//         isValid: false,
//         type: "error",
//         title: "Error",
//         message: "Project setup is incomplete. Please select both the reporting year and the frequency of each form to proceed.",
//       };
//     }

//     // Case 1: Year not selected, but Frequency selected
//     if (!hasYearSelection && formValidation.isValid) {
//       return {
//         isValid: false,
//         type: "warning",
//         title: "Warning",
//         message: "Please select the reporting year before completing the project setup. The year defines the time period for which your data will be captured.",
//       };
//     }

//     // Case 2: Frequency not selected, but Year selected
//     if (hasYearSelection && !formValidation.isValid) {
//       return {
//         isValid: false,
//         type: "warning",
//         title: "Warning",
//         message: "Please set the frequency for each form before completing the project setup. Frequency ensures how often the data will be collected and reported.",
//       };
//     }

//     // Case 4: Success - both selected
//     return {
//       isValid: true,
//       type: "success",
//       title: "Success",
//       message: "Project setup completed successfully. You can now assign forms to your users.",
//     };
//   };

//   // Fetch project details to pre-fill existing data
//   const fetchProjectDetails = async () => {
//     try {
//       setLoading(true);
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
//       });

//       if (response?.success) {
//         const projectData = response.data;

//         // Set year type and year value
//         if (projectData.year) {
//           setYearType(projectData.year); // "calendar" or "financial"
//         }
//         if (projectData.year_value) {
//           setSelectedYear(projectData.year_value); // "2023", "2021-2022", etc.
//         }

//         // Set standard form frequencies
//         if (
//           projectData.standard_form &&
//           Array.isArray(projectData.standard_form)
//         ) {
//           const standardFreqs = {};
//           projectData.standard_form.forEach((form) => {
//             if (form.id && form.frequency) {
//               standardFreqs[form.id] = convertFrequencyToFrontend(
//                 form.frequency,
//               );
//             }
//           });
//           setStandardFormFrequencies(standardFreqs);
//         }

//         // Set dynamic form frequencies - check for both dynamic_form and custom_form keys
//         const dynamicFormData =
//           projectData.dynamic_form || projectData.custom_form;
//         if (dynamicFormData && Array.isArray(dynamicFormData)) {
//           const dynamicFreqs = {};
//           dynamicFormData.forEach((form) => {
//             if (form.id && form.frequency) {
//               dynamicFreqs[form.id] = convertFrequencyToFrontend(
//                 form.frequency,
//               );
//             }
//           });
//           setDynamicFormFrequencies(dynamicFreqs);
//         }

//         console.log("Project details loaded:", {
//           yearType: projectData.year,
//           yearValue: projectData.year_value,
//           standardForms: projectData.standard_form,
//           customForms: projectData.custom_form,
//           dynamicForms: projectData.dynamic_form,
//           dynamicFormAccess: projectData.dynamic_form_access,
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching project details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const saveFrequencySettings = async () => {
//     try {
//       setLoading(true);

//       // Validate the project setup
//       const validation = validateProjectSetup();

//       if (!validation.isValid) {
//         triggerPopup(validation.type, validation.title, validation.message);
//         setLoading(false);
//         return;
//       }

//       // Prepare standard forms payload
//       const standardForms = tableData
//         .filter((item) => standardFormFrequencies[item._id])
//         .map((item) => ({
//           id: item._id,
//           frequency: convertFrequencyToBackend(
//             standardFormFrequencies[item._id],
//           ),
//         }));

//       // Prepare dynamic forms payload
//       const dynamicForms = dynamicTableData
//         .filter((item) => dynamicFormFrequencies[item._id])
//         .map((item) => ({
//           id: item._id,
//           frequency: convertFrequencyToBackend(
//             dynamicFormFrequencies[item._id],
//           ),
//         }));

//       const payload = {
//         year: yearType, // "calendar" or "financial"
//         year_value: selectedYear,
//         standard_form: standardForms,
//       };

//       // Only include dynamic_form in payload if there are selected dynamic forms
//       if (dynamicForms.length > 0) {
//         payload.dynamic_form = dynamicForms;
//       }

//       console.log("Sending payload:", payload);

//       const response = await postApi({
//         apiUrl: `/api/client/project/set-up/frequency/${projectId}`,
//         data: payload,
//       });

//       if (response?.success) {
//         // Show success popup using the validation message
//         triggerPopup(validation.type, validation.title, validation.message);

//         // Close the dialog after popup duration (3 seconds)
//         setTimeout(() => {
//           onClose();
//         }, 10000);
//       } else {
//         triggerPopup("error", "Error", response?.message || "Failed to save frequency settings");
//       }
//     } catch (error) {
//       console.error("Error saving frequency settings:", error);
//       triggerPopup("error", "Error", "An error occurred while saving frequency settings");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get placeholder text for year selection
//   const getYearPlaceholder = () => {
//     if (!yearType) return "Select Year";
//     return yearType === "financial"
//       ? "Select Financial Year"
//       : "Select Calendar Year";
//   };

//   // Check if setup is complete (for visual feedback)
//   const isSetupComplete = () => {
//     const validation = validateProjectSetup();
//     return validation.isValid;
//   };

//   const fetchTableData = useCallback(
//     async (searchValue = "") => {
//       try {
//         const response = await getApi({
//           apiUrl: API_URLS.GET_STANDARDFORM(projectId, searchValue),
//         });

//         if (response?.success) {
//           setTableData(response.data); // store full raw data
//         }
//       } catch (error) {
//         console.error("Error fetching standard survey forms:", error);
//       }
//     },
//     [projectId],
//   );

//   const fetchTableDataDynamic = useCallback(async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
//       });
//       if (response?.success) {
//         setDynamicTableData(response.data); // store raw API data
//       }
//     } catch (error) {
//       console.error("Error fetching dynamic forms:", error);
//     }
//   }, [projectId]);

//   const fetchUsers = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(user_data._id),
//       });

//       if (response.data) {
//         setRawUsers(response.data); // save raw data
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   useEffect(() => {
//     // Fetch project details first to pre-fill data
//     fetchProjectDetails();

//     // Then fetch other data
//     fetchTableData();
//     fetchTableDataDynamic();
//     fetchUsers();
//   }, [fetchTableData, fetchTableDataDynamic]);

//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
//       <div className="space-y-4 px-4 py-2">
//         <h3 className="text-lg text-[#000000]">Project Set-up</h3>
//         <hr />

//         {/* Select Project Admin */}
//         <div className="space-y-2">
//           <h4 className="text-base font-semibold">Select Project Admin</h4>

//           {/* Search Bar */}
//           <Input
//             placeholder="Search user"
//             prefix={<SearchOutlined />}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />

//           {/* Show filtered users only when searching */}
//           {searchTerm && (
//             <div className="space-y-2 pt-2 max-h-40 overflow-y-auto">
//               {filteredUsers.map((user) => (
//                 <div
//                   key={user._id}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md hover:bg-gray-50"
//                 >
//                   <span>{user.name}</span>
//                   <Checkbox
//                     checked={selectedUsers.includes(user.name)}
//                     onChange={() => handleUserCheck(user.name)}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Selected Users */}
//           {selectedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-gray-600">
//                 Selected Users:
//               </h5>
//               {selectedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-blue-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <Button
//                     size="small"
//                     type="text"
//                     onClick={() => handleUserCheck(name)}
//                     className="text-red-500"
//                   >
//                     Remove
//                   </Button>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Saved Users */}
//           {savedUsers.length > 0 && (
//             <div className="space-y-2 pt-2">
//               <h5 className="text-sm font-medium text-[#06513D]">
//                 Saved Project Admins:
//               </h5>
//               {savedUsers.map((name) => (
//                 <div
//                   key={name}
//                   className="flex justify-between items-center px-2 py-1 border rounded-md bg-green-50"
//                 >
//                   <span className="font-medium">{name}</span>
//                   <DeleteOutlined
//                     className="text-red-500 cursor-pointer hover:text-red-700 hover:scale-110 transition-all duration-200"
//                     onClick={() => showDeleteConfirm(name)}
//                     title={`Delete ${name}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Save Button */}
//           {selectedUsers.length > 0 && (
//             <div className="pt-2 px-4 flex justify-center">
//               <Button
//                 onClick={handleSave}
//                 style={{
//                   background: "#06513D",
//                   color: "white",
//                   borderRadius: "8px",
//                 }}
//               >
//                 Save Selected Users
//               </Button>
//             </div>
//           )}
//         </div>

//         {/* Select Year and Frequency */}
//         <div className="pt-6 space-y-4">
//           {/* Year Selection in Single Row */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year Type
//               </label>
//               <Select
//                 placeholder="Select Year Type"
//                 value={yearType}
//                 onChange={handleYearTypeChange}
//                 style={{ width: "100%" }}
//               >
//                 <Option value="financial">Financial Year</Option>
//                 <Option value="calendar">Calendar Year</Option>
//               </Select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 Select Year
//               </label>
//               <Select
//                 placeholder={getYearPlaceholder()}
//                 value={selectedYear}
//                 onChange={setSelectedYear}
//                 style={{ width: "100%" }}
//                 disabled={!yearType}
//               >
//                 {(yearType === "financial"
//                   ? financialYears
//                   : calendarYears
//                 ).map((year) => (
//                   <Option key={year} value={year}>
//                     {year}
//                   </Option>
//                 ))}
//               </Select>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-2">
//             {/* Column 1 */}
//             <div className="space-y-2">
//               {[frequencyOptions[0], frequencyOptions[1]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${selectedFrequency === freq
//                     ? "border-[#06513D] bg-green-50"
//                     : "border-gray-300"
//                     }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index]}</p>
//                 </div>
//               ))}
//             </div>

//             {/* Column 2 */}
//             <div className="space-y-2">
//               {[frequencyOptions[2], frequencyOptions[3]].map((freq, index) => (
//                 <div
//                   key={freq}
//                   className={`pt-2 pl-2 pr-2  h-20 flex flex-col justify-center items-start border rounded-md ${selectedFrequency === freq
//                     ? "border-[#06513D] bg-green-50"
//                     : "border-gray-300"
//                     }`}
//                 >
//                   <span className="font-medium text-sm block">{freq}</span>
//                   <p className="text-xs text-gray-500">{para[index + 2]}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="space-y-6">
//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Standard Form
//             </h5>
//             <div className="space-y-3">
//               {tableData.length > 0 ? (
//                 tableData.map((item) => (
//                   <div
//                     key={item._id}
//                     className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                   >
//                     <div className="flex items-center gap-2 w-full sm:w-auto">
//                       <span className="text-sm">{item.title}</span>
//                     </div>
//                     <Select
//                       placeholder="Frequency"
//                       style={{ width: 150 }}
//                       size="small"
//                       value={standardFormFrequencies[item._id]}
//                       onChange={(value) =>
//                         handleStandardFormFrequencyChange(item._id, value)
//                       }
//                     >
//                       {frequencyOptions.map((freq) => (
//                         <Option key={freq} value={freq}>
//                           {freq}
//                         </Option>
//                       ))}
//                     </Select>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center py-0 text-gray-500">
//                   <p className="text-sm">No data available</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="border rounded-md p-3">
//             <h5 className="text-sm font-semibold text-[#06513D] mb-3">
//               Dynamic Form
//             </h5>
//             <div className="space-y-3">
//               {dynamicTableData.length > 0 ? (
//                 dynamicTableData.map((item) => (
//                   <div
//                     key={item._id}
//                     className="flex flex-col sm:flex-row justify-between items-center gap-2 border p-2 rounded-md"
//                   >
//                     <div className="flex items-center gap-2 w-full sm:w-auto">
//                       <span className="text-sm">{item.title}</span>
//                     </div>
//                     <Select
//                       placeholder="Frequency"
//                       style={{ width: 150 }}
//                       size="small"
//                       value={dynamicFormFrequencies[item._id]}
//                       onChange={(value) =>
//                         handleDynamicFormFrequencyChange(item._id, value)
//                       }
//                     >
//                       {frequencyOptions.map((freq) => (
//                         <Option key={freq} value={freq}>
//                           {freq}
//                         </Option>
//                       ))}
//                     </Select>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center py-0 text-gray-500">
//                   <p className="text-sm">No data available</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="pt-2 px-4 flex justify-center">
// <Button
//   onClick={saveFrequencySettings}
//   loading={loading}
//   style={{
//     background: "#06513D",
//     color: "white",
//     borderRadius: "8px",
//   }}
//   disabled={statusFrequency === "unlock"}
// >
//   Complete Setup
// </Button>
//         </div>
//       </div>
//       {showPopup && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//           <PopupCard
//             type={popupData.type}
//             title={popupData.title}
//             message={popupData.message}
//           />
//         </div>
//       )}
//     </DialogBox>
//   );
// };

// export default ProjectSetup;

import React, { useState, useCallback, useEffect, useMemo } from "react";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Input, Checkbox, Button, Select, Modal, Empty } from "antd";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { fetchProjectById } from "../../../../../redux/ViewForm/viewFormSlice";
import PopupCard from "../../../../Auth/PopupCard";
import { Calendar, Info, ArrowRight } from "lucide-react";
const { Option } = Select;

const frequencyOptions = ["Yearly", "Half Yearly", "Quarterly", "Monthly"];

const para = [
  "(If the admin has chosen yearly, the system will assign one form or section to each user with a label.)",
  "(If the admin has chosen half-yearly, the system will assign two forms or sections to each user with a label.)",
  "If the admin has chosen quarterly, the system will assign four forms or sections to each user with a label.",
  "If the admin has chosen monthly, the system will assign 12 forms or sections to each user with a label.",
];

const ProjectSetup = ({
  onOpen,
  onClose,
  projectId,
  statusFrequency,
  onSetupComplete,
}) => {
  console.log("Status Frequency in ProjectSetup:", statusFrequency);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [savedUsers, setSavedUsers] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [yearType, setYearType] = useState(undefined);
  const [tableData, setTableData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const financialYears = [
    "2026-2027",
    "2025-2026",
    "2024-2025",
    "2023-2024",
    "2022-2023",
    "2021-2022",
  ];
  const calendarYears = ["2026", "2025", "2024", "2023", "2022", "2021"];
  const [dynamicTableData, setDynamicTableData] = useState([]);
  const [rawUsers, setRawUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
    onConfirm: null,
    onCancel: null,
  });

  // State to track individual form frequencies
  const [standardFormFrequencies, setStandardFormFrequencies] = useState({});
  const [dynamicFormFrequencies, setDynamicFormFrequencies] = useState({});
  const [lockedStandardFormIds, setLockedStandardFormIds] = useState([]);
  const [lockedDynamicFormIds, setLockedDynamicFormIds] = useState([]);

  // State to track if project setup is already completed
  const [isProjectSetupCompleted, setIsProjectSetupCompleted] = useState(false);

  const user_data = useSelector((state) => state.auth.user);

  // Automatically set the year type from organization settings (auth user) if locked
  useEffect(() => {
    if (user_data?.orgModeLocked && user_data?.reportingYearType) {
      setYearType(user_data.reportingYearType);
    }
  }, [user_data?.reportingYearType, user_data?.orgModeLocked]);

  const hasPendingFrequencySetup = useMemo(() => {
    const standardPending = tableData.some(
      (form) => !standardFormFrequencies[form._id],
    );
    const dynamicPending = dynamicTableData.some(
      (form) => !dynamicFormFrequencies[form._id],
    );
    return standardPending || dynamicPending;
  }, [
    tableData,
    dynamicTableData,
    standardFormFrequencies,
    dynamicFormFrequencies,
  ]);

  const hasSavableFrequencyChanges = useMemo(() => {
    const hasNewStandardFrequency = tableData.some(
      (form) =>
        !lockedStandardFormIds.includes(form._id) &&
        !!standardFormFrequencies[form._id],
    );

    const hasNewDynamicFrequency = dynamicTableData.some(
      (form) =>
        !lockedDynamicFormIds.includes(form._id) &&
        !!dynamicFormFrequencies[form._id],
    );

    return hasNewStandardFrequency || hasNewDynamicFrequency;
  }, [
    tableData,
    dynamicTableData,
    lockedStandardFormIds,
    lockedDynamicFormIds,
    standardFormFrequencies,
    dynamicFormFrequencies,
  ]);
  const clientId = user_data?.client_id?._id || user_data?._id;
  const user_data1 = useSelector((state) => state);
  const dispatch = useDispatch();
  console.log(user_data1, "userdatatatta");
  const handleYearTypeChange = (value) => {
    if (isProjectSetupCompleted) {
      triggerPopup(
        "error",
        "Cannot Edit",
        "The reporting year and form frequency cannot be changed after project setup is completed. Please contact the CARBURN Support Team if you need assistance.",
      );
      return;
    }
    setYearType(value);
    setSelectedYear(null);
  };

  const handleYearChange = (value) => {
    if (isProjectSetupCompleted) {
      triggerPopup(
        "error",
        "Cannot Edit",
        "The reporting year and form frequency cannot be changed after project setup is completed. Please contact the CARBURN Support Team if you need assistance.",
      );
      return;
    }
    setSelectedYear(value);
  };

  const handleFormFrequencyChange = (
    formId,
    frequency,
    isStandardForm = true,
  ) => {
    const isLocked = isStandardForm
      ? lockedStandardFormIds.includes(formId)
      : lockedDynamicFormIds.includes(formId);

    if (isLocked) {
      triggerPopup(
        "error",
        "Cannot Edit",
        "Frequency for this form is already configured and cannot be changed.",
      );
      return;
    }
    if (isStandardForm) {
      setStandardFormFrequencies((prev) => ({ ...prev, [formId]: frequency }));
    } else {
      setDynamicFormFrequencies((prev) => ({ ...prev, [formId]: frequency }));
    }
  };

  const filteredUsers = useMemo(() => {
    return rawUsers.filter((user) =>
      (user.name || "").toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [searchTerm, rawUsers]);

  const handleUserCheck = (name) => {
    setSelectedUsers((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name],
    );
  };

  const handleSave = () => {
    setSavedUsers((prev) => [...prev, ...selectedUsers]);
    setSelectedUsers([]);
  };

  const showDeleteConfirm = (name) => {
    setSavedUsers((prev) => prev.filter((n) => n !== name));
  };

  const handleDelete = (name) => {
    setSavedUsers((prev) => prev.filter((n) => n !== name));
    setSelectedUsers((prev) => prev.filter((n) => n !== name));
  };

  const triggerPopup = (
    type,
    title,
    message,
    duration = 3000,
    onConfirm = null,
    onCancel = null,
  ) => {
    setPopupData({ type, title, message, onConfirm, onCancel });
    setShowPopup(true);
    if (!onConfirm && !onCancel) {
      setTimeout(() => setShowPopup(false), duration);
    }
  };

  const convertFrequencyToFrontend = (frequency) => {
    const frequencyMap = {
      year: "Yearly",
      half_year: "Half Yearly",
      quaterly: "Quarterly",
      monthly: "Monthly",
    };
    return frequencyMap[frequency] || frequency;
  };

  const convertFrequencyToBackend = (frequency) => {
    const frequencyMap = {
      Yearly: "year",
      "Half Yearly": "half_year",
      Quarterly: "quaterly",
      Monthly: "monthly",
    };
    return frequencyMap[frequency] || frequency.toLowerCase();
  };

  // VALIDATION: returns { isValid, skipFrequencyCheck?, message }
  const validateFormFrequencies = () => {
    const totalStandardForms = tableData.length;
    const totalDynamicForms = dynamicTableData.length;
    const totalAvailableForms = totalStandardForms + totalDynamicForms;

    // If no forms available at all → skip frequency validation
    if (totalAvailableForms === 0) {
      return { isValid: true, skipFrequencyCheck: true };
    }

    const allStandardFormsHaveFrequency =
      totalStandardForms === 0 ||
      tableData.every((form) => !!standardFormFrequencies[form._id]);

    const allDynamicFormsHaveFrequency =
      totalDynamicForms === 0 ||
      dynamicTableData.every((form) => !!dynamicFormFrequencies[form._id]);

    if (!allStandardFormsHaveFrequency || !allDynamicFormsHaveFrequency) {
      return {
        isValid: false,
        skipFrequencyCheck: false,
        message:
          "Please set the frequency for each form before completing the project setup. Frequency ensures how often the data will be collected and reported.",
      };
    }

    return { isValid: true, skipFrequencyCheck: false };
  };

  const validateProjectSetup = () => {
    const hasYearSelection = !!yearType && !!selectedYear;
    const formValidation = validateFormFrequencies();

    // If frequency checks are skipped (no forms exist)
    if (formValidation.skipFrequencyCheck) {
      if (!hasYearSelection) {
        return {
          isValid: false,
          type: "warning",
          title: "Warning",
          message:
            "Please select the reporting year before completing the project setup.",
        };
      }
      return {
        isValid: true,
        type: "success",
        title: "Success",
        message:
          "Project setup completed successfully. You can now assign forms to your users.",
      };
    }

    // If frequency checks are required (forms exist), apply standard logic
    // Case: both missing or invalid
    if (!hasYearSelection && !formValidation.isValid) {
      return {
        isValid: false,
        type: "error",
        title: "Error",
        message:
          "Project setup is incomplete. Please select both the reporting year and the frequency of each form to proceed.",
      };
    }

    // Year missing but frequencies ok
    if (!hasYearSelection && formValidation.isValid) {
      return {
        isValid: false,
        type: "warning",
        title: "Warning",
        message:
          "Please select the reporting year before completing the project setup. The year defines the time period for which your data will be captured.",
      };
    }

    // Year present but frequency invalid
    if (hasYearSelection && !formValidation.isValid) {
      return {
        isValid: false,
        type: "warning",
        title: "Warning",
        message:
          formValidation.message ||
          "Please set the frequency for each form before completing the project setup. Frequency ensures how often the data will be collected and reported.",
      };
    }

    // success
    return {
      isValid: true,
      type: "success",
      title: "Success",
      message:
        "Project setup completed successfully. You can now assign forms to your users.",
    };
  };

  const proceedWithSave = async () => {
    try {
      setLoading(true);

      const standardForms = tableData
        .filter((item) => !!standardFormFrequencies[item._id])
        .map((item) => ({
          id: item._id,
          frequency: convertFrequencyToBackend(
            standardFormFrequencies[item._id],
          ),
        }));

      const dynamicForms = dynamicTableData
        .filter((item) => !!dynamicFormFrequencies[item._id])
        .map((item) => ({
          id: item._id,
          frequency: convertFrequencyToBackend(
            dynamicFormFrequencies[item._id],
          ),
        }));

      const payload = {
        year: yearType,
        year_value: selectedYear,
        standard_form: standardForms,
        dynamic_form: dynamicForms, // Always send, even if empty
      };

      console.log("Sending payload:", payload);

      const response = await postApi({
        apiUrl: `/api/client/project/set-up/frequency/${projectId}`,
        data: payload,
      });

      if (response?.success) {
        setIsProjectSetupCompleted(true);
        triggerPopup(
          "success",
          "Success",
          "Project setup completed successfully. You can now assign forms to your users.",
        );
        // setTimeout(() => {
        //   onClose();
        // }, 3000);
        setTimeout(() => {
          onClose();
          // ✅ Call the callback to refresh parent data
          if (onSetupComplete) {
            onSetupComplete();
          }
        }, 3000);
      } else {
        triggerPopup(
          "error",
          "Error",
          "Unable to complete project setup. Please try again or contact support.",
        );
      }
    } catch (error) {
      console.error("Error saving frequency settings:", error);
      triggerPopup(
        "error",
        "Error",
        "An error occurred while saving frequency settings",
      );
    } finally {
      setLoading(false);
    }
  };

  const saveFrequencySettings = async () => {
    const validation = validateProjectSetup();

    if (!validation.isValid) {
      triggerPopup(validation.type, validation.title, validation.message);
      return;
    }

    // show confirmation popup (no auto-close)
    triggerPopup(
      "warning",
      "Project Setup",
      "Please review your selections carefully before completing the project setup. Once saved, the reporting year and form frequency cannot be changed.",
      0,
      () => {
        // confirm
        setShowPopup(false);
        proceedWithSave();
      },
      () => {
        // cancel
        setShowPopup(false);
        console.log("User cancelled the setup");
      },
    );
  };

  const fetchProjectDetails = async () => {
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
      });

      // ✅ Also dispatch to Redux to keep project details synced
      dispatch(fetchProjectById(projectId));

      if (response?.success) {
        const projectData = response.data;

        const hasExistingSetup =
          projectData.status === "Project Setup Completed";

        setIsProjectSetupCompleted(hasExistingSetup);
        if (hasExistingSetup) {
          if (projectData.year) setYearType(projectData.year);
          if (projectData.year_value) setSelectedYear(projectData.year_value);
        } else if (user_data?.orgModeLocked && user_data?.reportingYearType) {
          setYearType(user_data.reportingYearType);
        }
        if (
          projectData.standard_form &&
          Array.isArray(projectData.standard_form)
        ) {
          const standardFreqs = {};
          const lockedStandardIds = [];
          projectData.standard_form.forEach((form) => {
            if (form.id && form.frequency) {
              standardFreqs[form.id] = convertFrequencyToFrontend(
                form.frequency,
              );
              lockedStandardIds.push(form.id);
            }
          });
          setStandardFormFrequencies(standardFreqs);
          setLockedStandardFormIds(lockedStandardIds);
        }

        const dynamicFormData =
          projectData.dynamic_form || projectData.custom_form;
        if (dynamicFormData && Array.isArray(dynamicFormData)) {
          const dynamicFreqs = {};
          const lockedDynamicIds = [];
          dynamicFormData.forEach((form) => {
            if (form.id && form.frequency) {
              dynamicFreqs[form.id] = convertFrequencyToFrontend(
                form.frequency,
              );
              lockedDynamicIds.push(form.id);
            }
          });
          setDynamicFormFrequencies(dynamicFreqs);
          setLockedDynamicFormIds(lockedDynamicIds);
        }

        console.log("Project details loaded:", {
          yearType: projectData.year,
          yearValue: projectData.year_value,
          standardForms: projectData.standard_form,
          customForms: projectData.custom_form,
          dynamicForms: projectData.dynamic_form,
          dynamicFormAccess: projectData.dynamic_form_access,
          isSetupCompleted: hasExistingSetup,
        });
      }
    } catch (error) {
      console.error("Error fetching project details:", error);
    } finally {
      setLoading(false);
    }
  };

  const getYearPlaceholder = () => {
    if (!yearType) return "Select Year";
    return yearType === "financial"
      ? "Select Financial Year"
      : "Select Calendar Year";
  };

  const fetchTableData = useCallback(
    async (searchValue = "", page = 1, isAppend = false) => {
      try {
        if (page === 1) {
          setLoading(true);
        } else {
          setLoadingMore(true);
        }
        const limit = 10;
        const skip = (page - 1) * limit;
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARDFORM(
            projectId,
            searchValue,
            page,
            limit,
            skip,
          ),
        });
        if (response?.success) {
          const newData = response.data || [];
          if (isAppend) {
            setTableData((prev) => {
              const existingIds = new Set(prev.map((item) => item._id));
              const filteredNewData = newData.filter(
                (item) => !existingIds.has(item._id),
              );
              return [...prev, ...filteredNewData];
            });
          } else {
            setTableData(newData);
          }
          if (newData.length < limit) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          setPageNo(page);
        }
      } catch (error) {
        console.error("Error fetching standard survey forms:", error);
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [projectId],
  );

  const fetchTableDataDynamic = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
      });
      if (response?.success) setDynamicTableData(response.data);
    } catch (error) {
      console.error("Error fetching dynamic forms:", error);
    }
  }, [projectId]);

  const fetchUsers = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(clientId),
      });
      if (response.data) setRawUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchProjectDetails();
    fetchTableData();
    fetchTableDataDynamic();
    fetchUsers();
  }, [fetchTableData, fetchTableDataDynamic]);

  const YearlyIcon = () => (
    <svg
      className="w-5 h-5 text-[#06513D]"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <text
        x="15"
        y="19"
        fontSize="10"
        fontFamily="Georgia, serif"
        fontWeight="bold"
        fill="#06513D"
        textAnchor="middle"
      >
        Y
      </text>
    </svg>
  );

  const HalfYearlyIcon = () => (
    <svg
      className="w-5 h-5 text-[#06513D]"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <text
        x="14"
        y="18"
        fontSize="8"
        fontFamily="Georgia, serif"
        fontWeight="bold"
        fill="#06513D"
        textAnchor="middle"
      >
        1/2
      </text>
    </svg>
  );

  const QuarterlyIcon = () => (
    <svg
      className="w-5 h-5 text-[#06513D]"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <text
        x="15"
        y="19"
        fontSize="10"
        fontFamily="Georgia, serif"
        fontWeight="bold"
        fill="#06513D"
        textAnchor="middle"
      >
        Q
      </text>
    </svg>
  );

  const MonthlyIcon = () => (
    <svg
      className="w-5 h-5 text-[#06513D]"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <text
        x="14"
        y="19"
        fontSize="9"
        fontFamily="Georgia, serif"
        fontWeight="bold"
        fill="#06513D"
        textAnchor="middle"
      >
        M
      </text>
    </svg>
  );

  const freqGuideData = [
    {
      freq: "Yearly",
      icon: <Calendar />,
      text: "User will get 1 form to fill data for the reporting year.",
    },
    {
      freq: "Half Yearly",
      icon: <Calendar />,
      text: "User will get 2 forms to fill data for the reporting year.",
    },
    {
      freq: "Quarterly",
      icon: <Calendar />,
      text: "User will get 4 forms to fill data for the reporting year.",
    },
    {
      freq: "Monthly",
      icon: <Calendar />,
      text: "User will get 12 forms to fill data for the reporting year.",
    },
  ];

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
      <div className="px-6 py-5 font-sans max-h-[85vh] overflow-y-auto custom-scrollbar">
        {/* Title Header */}
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-[20px] font-bold text-gray-900 m-0">
              Project Set-up
            </h3>
            <p className="text-[13px] text-gray-500 m-0 mt-1">
              Configure your project period and reporting frequency.
            </p>
          </div>
        </div>
        <div className="border-b border-gray-100 my-4" />

        {/* Dropdowns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-4">
          <div>
            <label className="block text-[13px] font-bold text-gray-800 mb-1.5">
              Select Year Type
            </label>
            <Select
              placeholder={
                <span className="flex items-center gap-2 text-gray-400 text-xs">
                  <Calendar className="w-4 h-4" />
                  Select Year Type
                </span>
              }
              value={yearType}
              onChange={handleYearTypeChange}
              style={{ width: "100%", height: "40px" }}
              className="custom-setup-select"
              disabled={true}
              options={[
                {
                  value: "financial",
                  label: (
                    <span className="flex items-center gap-2 text-xs">
                      <Calendar className="w-4 h-4 text-[#06513D]" />
                      Financial Year
                    </span>
                  ),
                },
                {
                  value: "calendar",
                  label: (
                    <span className="flex items-center gap-2 text-xs">
                      <Calendar className="w-4 h-4 text-[#06513D]" />
                      Calendar Year
                    </span>
                  ),
                },
              ]}
            />
          </div>

          <div>
            <label className="block text-[13px] font-bold text-gray-800 mb-1.5">
              Select Year
            </label>
            <Select
              placeholder={
                <span className="flex items-center gap-2 text-gray-400 text-xs">
                  <Calendar className="w-4 h-4" />
                  {getYearPlaceholder()}
                </span>
              }
              value={selectedYear}
              onChange={handleYearChange}
              disabled={isProjectSetupCompleted || !user_data?.orgModeLocked}
              style={{ width: "100%", height: "40px" }}
              className="custom-setup-select"
              options={(yearType === "financial"
                ? financialYears
                : calendarYears
              ).map((year) => ({
                value: year,
                label: (
                  <span className="flex items-center gap-2 text-xs">
                    <Calendar className="w-4 h-4 text-[#06513D]" />
                    {year}
                  </span>
                ),
              }))}
            />
          </div>
        </div>

        {/* Frequency Guide Box */}
        <div className="border border-emerald-100 bg-[#FAFDFD] rounded-xl p-4 mt-6">
          <div className="flex items-center gap-2 mb-3 text-[#06513D] font-bold text-[13.5px]">
            <Info className="w-4.5 h-4.5 text-[#06513D] shrink-0" />
            <span>Frequency Guide</span>
          </div>
          <div className="border border-gray-100 rounded-lg overflow-hidden bg-white">
            {freqGuideData.map((item, idx) => (
              <div
                key={item.freq}
                className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 last:border-b-0"
              >
                <div className="flex items-center gap-2 w-[120px] shrink-0">
                  <div className="w-8 h-8 flex items-center text-[#06513D] justify-center ">
                    {item.icon}
                  </div>
                  <span className="font-bold text-[#06513D] text-[13px]">
                    {item.freq}
                  </span>
                </div>
                <div className="text-gray-400 mx-1 shrink-0">
                  <ArrowRight className="w-4 h-4" />
                </div>
                <div className="flex-1 text-left text-[12px] text-black pl-2">
                  {item.text}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Standard Forms list */}
        <div className="border border-gray-100 rounded-xl p-4 mt-6">
          <h4 className="text-[14px] font-bold text-[#06513D] m-0 mb-3">
            Standard Forms
          </h4>
          <div
            className="divide-y divide-gray-100 max-h-[250px] overflow-y-auto pr-2 custom-scrollbar"
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.target;
              if (
                scrollHeight - scrollTop - clientHeight < 20 &&
                hasMore &&
                !loading &&
                !loadingMore
              ) {
                fetchTableData(searchTerm, pageNo + 1, true);
              }
            }}
          >
            {tableData.length > 0 ? (
              <>
                {tableData.map((item) => (
                  <div
                    key={item._id}
                    className="flex justify-between items-center py-2.5"
                  >
                    <span className="text-[13px] text-gray-800 font-medium">
                      {item.title}
                    </span>
                    <Select
                      placeholder="Frequency"
                      style={{ width: 140, height: "32px" }}
                      value={standardFormFrequencies[item._id]}
                      disabled={lockedStandardFormIds.includes(item._id)}
                      onChange={(value) =>
                        handleFormFrequencyChange(item._id, value, true)
                      }
                      options={frequencyOptions.map((freq) => ({
                        value: freq,
                        label: freq,
                      }))}
                    />
                  </div>
                ))}
                {loadingMore && (
                  <div className="text-center py-2 text-xs text-gray-400 font-medium">
                    Loading more forms...
                  </div>
                )}
              </>
            ) : (
              <div className="py-4">
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  imageStyle={{ height: 35 }}
                  description={
                    <span className="text-xs text-gray-400">No data</span>
                  }
                />
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 mt-8 pt-4 border-t border-gray-100">
          <Button
            onClick={onClose}
            className="!border-[#06513D] bg-[#E6EDEB] !text-[#06513D] rounded-lg h-9 text-[13px] px-5 hover:!bg-[#F8F8F8] "
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (isProjectSetupCompleted && !hasSavableFrequencyChanges) {
                triggerPopup(
                  "warning",
                  "No Pending Forms",
                  "All assigned forms already have frequency configured. Assign a new form to configure its frequency.",
                );
                return;
              }
              saveFrequencySettings();
            }}
            loading={loading}
            className="bg-[#06513D] hover:!bg-[#387464] text-white rounded-lg h-9 text-[13px] px-5 border-none"
            style={{
              background: "#06513D",
              color: "white",
            }}
          >
            {isProjectSetupCompleted
              ? hasPendingFrequencySetup
                ? "Save & Continue"
                : "Setup Completed"
              : "Save & Continue"}
          </Button>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
            onConfirm={popupData.onConfirm}
            onCancel={popupData.onCancel}
            confirmText="Confirm & Save"
            cancelText="Go Back"
          />
        </div>
      )}
    </DialogBox>
  );
};

export default ProjectSetup;
